import React from 'react';

const Contact = () => {
    return (
        <>
            <div className="contact-form section-padding">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-7">
                            <div className="section-title text-center">
                                <span>Ask Question</span>
                                <h2>Let us hear from you directly!</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-xl-4 col-md-4 col-sm-12">
    <div className="info-list">
        <h4 className="mb-3">Address</h4>
        <ul>
        <li>
    <i className="fa-solid fa-location-dot"></i>
    <a href="https://www.google.com/maps?q=California, USA" target="_blank" rel="noopener noreferrer">
    Ahmedabad, India 
    </a>
</li>

            <li>
                <i className="fa fa-phone"></i>
                <a href="tel:+8801243665566">(+91) 12436 65566</a>
            </li>
            <li>
                <i className="fa fa-envelope"></i>
                <a href="mailto:hello@example.com">hello@example.com</a>
            </li>
        </ul>
    </div>
</div>
                        <div className="col-xl-8 col-md-8 col-sm-12">
                            <form method="post" name="myform" className="contact_validate">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="contactName"
                                                placeholder="Your Name"
                                                name="name"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="email"
                                                placeholder="hello@domain.com"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Phone</label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                name="phone"
                                                placeholder="+1 234 567 890"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Inquiry Type</label>
                                            <select className="form-select" name="inquiryType" required>
                                                <option value="" disabled selected>Select Inquiry Type</option>
                                                <option value="general">General Inquiry</option>
                                                <option value="support">Support</option>
                                                <option value="sales">Sales</option>
                                                <option value="feedback">Feedback</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">Message</label>
                                            <textarea
                                                className="form-control p-3"
                                                name="message"
                                                rows="5"
                                                placeholder="Tell us what we can help you with!"
                                                required
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary my-4">
                                    Send message
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12 p-0">
                    <div id="map-canvas" style={{ width: '100%', height: '450px' }}>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235014.15049961975!2d72.5797426!3d23.0202434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e848aba5bd449%3A0x4fcedd11614f6516!2sAhmedabad%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1746618385297!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Ahmedabad Map"
                        ></iframe>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Contact;
